module.exports = {
    wrongSchemeType: 'Unknown scheme type "%s"',
    wrongConditionOperator: 'Wrong condition operator: "%s"',
    wrongBlockOperator: 'Wrong block operator: "%s"',
    wrongContent: 'Wrong content "%s"',
    nonExistNode: 'No such node %s'
};
